import React from 'react'
import PropTypes from 'prop-types'

// component
import { Card, CardBody, Col, Row } from 'reactstrap'
import TimeUtil from 'utils/time-util'

const propTypes = {
  internal_request: PropTypes.shape({
    id             : PropTypes.number,
    code           : PropTypes.string,
    purpose        : PropTypes.string,
    status         : PropTypes.string,
    requested_date : PropTypes.string,
    returned_date  : PropTypes.string,
    notes          : PropTypes.string,
    requestor      : PropTypes.shape({
      name  : PropTypes.string,
      email : PropTypes.string
    })
  })
}

/**
 * Show card information about Internal Request
 * @param {object} internal_request  Internal Request
 */
const InternalRequestCard = ({ internal_request }) => (
  <Card>
    <CardBody>
      <Row>
        <Col xs={ 6 }>
          <div className='mb-3'>
            <h2 className='text-uppercase text-primary font-weight-bolder'>Purpose</h2>
            <h2 className='mb-0'>{ internal_request.purpose }</h2>
          </div>
        </Col>
        <Col xs={ 6 }>
          <div className='mb-3'>
            <h2 className='text-uppercase text-primary font-weight-bolder'>Requestor</h2>
            <h2 className='mb-0'>{ internal_request.requestor?.name || '-' }</h2>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={ 6 }>
          <div className='mb-3'>
            <h2 className='text-uppercase text-primary font-weight-bolder'>Requested Date</h2>
            <h2 className='mb-0'>{ TimeUtil.format(internal_request.requested_date) }</h2>
          </div>
        </Col>
        <Col xs={ 6 }>
          <div className='mb-3'>
            <h2 className='text-uppercase text-primary font-weight-bolder'>Returned Date</h2>
            <h2 className='mb-0'>{ TimeUtil.format(internal_request.returned_date) }</h2>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={ 12 }>
          <div className='mb-3'>
            <h2 className='text-uppercase text-primary font-weight-bolder'>Notes / Description</h2>
            <h2 className='mb-0'>{ internal_request.notes || '-' }</h2>
          </div>
        </Col>
      </Row>
    </CardBody>
  </Card>
)

InternalRequestCard.propTypes = propTypes

export default InternalRequestCard